module.exports = __webpack_public_path__ + "static/media/login_vandor_logo.93f0dc5b.png";